import * as React from "react";
import { Flex, ScrollArea, Spinner } from "@radix-ui/themes";
import { v0_9 } from "@a2ui-sdk/react";
import { useChat } from "../hooks/useChat";
import { MarkdownTextComponent } from "./MarkdownRenderer";
import { customCatalogComponents } from "./CatalogComponents";
import { ChatMessage } from "./ChatMessage";
import { ChatInput } from "./ChatInput";
import "./Chat.css";

const { standardCatalog } = v0_9;

const Chat: React.FC = () => {
  const customCatalog = React.useMemo(() => {
    return {
      ...standardCatalog,
      components: {
        ...(standardCatalog?.components || {}),
        ...customCatalogComponents,
      },
    };
  }, []);

  const {
    messages,
    inputValue,
    attachedFiles,
    isLoading,
    isInitializing,
    fileInputRef,
    textareaRef,
    endOfMessagesRef,
    handleSend,
    handleCancelRun,
    handleKeyDown,
    handleInputChange,
    handleFileChange,
    removeFile,
  } = useChat();

  if (isInitializing) {
    return (
      <Flex align="center" justify="center" style={{ height: "100%" }} className="chat-container">
        <Spinner size="3" />
      </Flex>
    );
  }

  return (
    <Flex direction="column" className="chat-container">
      <ScrollArea className="chat-scroll-area" scrollbars="vertical">
        <Flex direction="column" gap="4" className="chat-messages-container">
          {messages.map((msg) => (
            <ChatMessage key={msg.id} msg={msg} customCatalog={customCatalog} onSendAction={handleSend} />
          ))}
          <div ref={endOfMessagesRef} />
        </Flex>
      </ScrollArea>

      <ChatInput
        inputValue={inputValue}
        attachedFiles={attachedFiles}
        isLoading={isLoading}
        fileInputRef={fileInputRef}
        textareaRef={textareaRef}
        handleSend={handleSend}
        handleCancelRun={handleCancelRun}
        handleKeyDown={handleKeyDown}
        handleInputChange={handleInputChange}
        handleFileChange={handleFileChange}
        removeFile={removeFile}
      />
    </Flex>
  );
};

export default Chat;
